import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/tesla/list',
  name: ROUTE_NAME.TESLA_LIST,
  meta: {
    title: '我的奖券',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "tesla" */
      '@/pages/tesla/list.vue'),
      loading: Loading
    };
  }
}, {
  path: '/tesla/index',
  name: ROUTE_NAME.TESLA_INDEX,
  meta: {
    title: '百日跑报名特斯拉开回家 ',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "tesla" */
      '@/pages/tesla/index.vue'),
      loading: Loading
    };
  }
}];